export const getDataScienceApiUrl = () => '/api';
